<template>
  <div>
    <el-row>
      <el-col align="right" style="height: 40px;">
        <el-button type="primary" @click="handleAddService">新增</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="serviceDataList">
      <el-table-column label="订单编号" min-width="100" align="left">
        <template slot-scope="scope">
          <el-link
            type="primary"
            class="crm-link-wrap"
            :underline="false"
            @click="$jump.service(scope.row.id, '_blank')"
          >{{scope.row.orderNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" align="left" prop="orderStatusDesc"></el-table-column>
      <el-table-column label="问题类型" align="left" prop="problemJudges"></el-table-column>
      <el-table-column label="服务费用(元)" align="left" prop="serviceFee">
        <template slot-scope="scope">
          <span v-if="scope.row.serviceFee !== 0">{{ amountFormat(Number(scope.row.serviceFee || 0)) }}元</span>
          <span v-else>免费</span>
        </template>
      </el-table-column>
      <el-table-column label="问题日期" align="left" prop="problemHappenDate"></el-table-column>
      <el-table-column label="处理日期" align="left" prop="dealDate"></el-table-column>
      <el-table-column label="负责人" align="center" prop="managerName" />
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <!-- 新增服务单 -->
    <ServiceOrderAddDialog ref="serviceOrderAddDialogRef" @success="queryList"></ServiceOrderAddDialog>
  </div>
</template>

<script>
import {
  listServiceByPage, // 查询服务订单
} from "@/api/crm/order"; 
import { amountFormat } from "@/utils/index";
import ServiceOrderAddDialog from "@/views/crm/service/serviceOrderAddDialog";

export default {
  name: "ContractList",
  props: {
    customerId: {},
    deliveryOrderId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      loading: false,
      serviceDataList: [],
      amountFormat,
      total: 0,
      otherData: {
        totalContractAmount: 0, // 合同总额
        totalSignContractAmount: 0, // 已签约
        totalFundedAmount: 0 // 已回款
      },
      queryParams: {
        pageNum: 1,
        pageSize: 20
      }
    };
  },
  created() {
    if (this.deliveryOrderId || this.customerId) {
      this.queryList();
    }
  },
  components: {
    ServiceOrderAddDialog
  },
  watch: {
    deliveryOrderId(val) {
      if (val) {
        this.queryList();
      } else {
        this.serviceDataList = [];
      }
    },
    customerId(val) {
      if (val) {
        this.queryList();
      } else {
        this.serviceDataList = [];
      }
    }
  },
  methods: {
    /** 新增服务按钮操作 */
    handleAddService() {
      this.$refs.serviceOrderAddDialogRef.open(this.customerId, this.deliveryOrderId);
    },
    queryList() {
      this.loading = true;
      listServiceByPage({
        ...this.queryParams,
        deliveryOrderId: this.deliveryOrderId,
        customerId: this.customerId
      })
        .then(response => {
          const { total, otherData, rows, msg, code } = response;
          this.loading = false;
          if (code == 200) {
            this.serviceDataList = rows || [];
            this.total = total;
            this.otherData = otherData || {};
            this.$emit("after-query", this.serviceDataList);
          } else {
            this.$message.error(msg || "服务单列表获取异常");
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.error(error.msg || "服务单列表获取异常");
        });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.id, "_blank");
    },
    toUserDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank");
    },
    /** 详细按钮操作 */
    toBusinessDetail(row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .pagination-container {
  padding: 10px 0px 32px !important;
}
</style>
